import { FormattedMessage } from 'dibs-react-intl';
import serverVars from 'server-vars';

import { validateRegex } from '../../common/helpers/formValidationHelpers.tsx';

const specialCharsAddress = /^[^!@$%^&*()+=><?]*$/;
const usZipCode = /^\d{5}(?:[-\s]?\d{4})?$/;
const globalZipCode = /^[a-zA-Z0-9\s\-]{1,9}$/;
const eori = /^[a-zA-Z]{2}[a-zA-Z0-9]{6,}$/;

export function arrayIsNotEmpty(field) {
    if (!Array.isArray(field) || (field || []).length === 0) {
        return (
            <FormattedMessage
                id="sellerApplicationValidationHelpers.emptyArray"
                defaultMessage="This field is required"
            />
        );
    }
    return null;
}

export function noSpecialCharactersAddress(field) {
    return validateRegex(
        field,
        specialCharsAddress,
        <FormattedMessage
            id="sellerApplicationValidationHelpers.specialCharsAddress"
            defaultMessage="Should not contain special characters: !@$%^&*()+=><?"
        />
    );
}

export function zipCodeIsInvalid({ country, zipCode }) {
    if (country === 'US') {
        return validateRegex(
            zipCode,
            usZipCode,
            <FormattedMessage
                id="sellerApplicationValidationHelpers.usZip"
                defaultMessage="Please enter a valid U.S. ZIP code"
            />
        );
    }
    return validateRegex(
        zipCode,
        globalZipCode,
        <FormattedMessage
            id="sellerApplicationValidationHelpers.nonUSZip"
            defaultMessage="This field may only contain no more than 9 letters, numbers, spaces, and hyphens"
        />
    );
}

export const isEstimatedInventorySizeOverLimit = val => {
    const numberVal = Number(val);
    const limit = 999999; // max value provided by salesforce
    if (numberVal > limit) {
        const locale = serverVars.get('locale');
        const limitFormatted = new Intl.NumberFormat(locale || 'en-US').format(limit);
        return (
            <FormattedMessage
                id="sellerApplicationValidationHelpers.isEstInventorySizeOverLimit"
                defaultMessage="Estimated inventory size may be no greater than {limit}"
                values={{ limit: limitFormatted }}
            />
        );
    }
    return null;
};

export function validateEori(field) {
    return validateRegex(
        field,
        eori,
        <FormattedMessage
            id="sellerApplicationValidationHelpers.eori"
            defaultMessage="Invalid EORI Number"
        />
    );
}
